import { useDataValue, useDataFormat } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  let board_ids = useDataFormat({
    context: 'selected',
    path: 'tasks',
    format: value => value.map(item => item.board_id),
    viewPath: props.viewPath,
  })

  let assignee_ids = useDataValue({
    context: 'selected',
    path: 'assignees',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_id,
      board_ids,
      assignee_ids,
      hasAssignee: !!assignee_ids.length > 0,
    },
  }
}
